import { useMemo } from "react";

export default function TicketGrid({ total, selected, soldNumbers, onToggle, winner }) {
    const sold = useMemo(() => new Set(soldNumbers || []), [soldNumbers]);
    const sel = useMemo(() => new Set(selected || []), [selected]);
    const nums = useMemo(() => Array.from({ length: total }, (_, i) => i + 1), [total]);

    return (
        <div className="grid grid-cols-5 sm:grid-cols-8 md:grid-cols-10 gap-2" data-testid="ticket-grid">
            {nums.map((n) => {
                const isSold = sold.has(n);
                const isSelected = sel.has(n);
                const isWinner = winner === n;
                const cls = [
                    "ticket",
                    isWinner ? "ticket-winner" : "",
                    isSold && !isWinner ? "ticket-sold" : "",
                    isSelected && !isSold ? "ticket-selected" : "",
                ].join(" ");
                return (
                    <button
                        key={n}
                        type="button"
                        disabled={isSold}
                        onClick={() => onToggle?.(n)}
                        className={cls}
                        data-testid={`ticket-${n}`}
                        aria-label={`Boleto ${n}`}
                    >
                        {String(n).padStart(String(total).length, "0")}
                    </button>
                );
            })}
        </div>
    );
}
